/* eslint-disable react-hooks/exhaustive-deps */
import Stack from "@mui/material/Stack"
import { TextFieldProps } from "@mui/material/TextField"
import { useRouter } from "next/router"
import { ChangeEvent, KeyboardEvent, useEffect, useMemo, useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import dynamic from "next/dynamic";
import { useLayoutData } from "../../../../utils/contexts/LayoutContext";
import { FindButtonProps } from "../FindDesignTypes";
import { filterUrl } from "../Find";
import { NumericFormat } from 'react-number-format';
import { PageType } from "../../../../pages/_app";
import { FilterBaseProps } from "../Find.types";

const FilterLongInterval = ({
  filters,
  colors,
  pageUrl,
  mmbr,
  isMobile
}: FilterBaseProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()

  const [minValue, setMinValue] = useState<number | undefined>(filters?.intervalSelectedMin !== undefined ? filters?.intervalSelectedMin : undefined)
  const [maxValue, setMaxValue] = useState<number | undefined>(filters?.intervalSelectedMax !== undefined ? filters?.intervalSelectedMax : undefined)
  const [longIntervalSearchTimeout, setLongIntervalSearchTimeout] = useState<NodeJS.Timeout | undefined>()
  
  const hasMinValue = minValue !== undefined
  const hasMaxValue = maxValue !== undefined
  const hasOneValue = hasMinValue || hasMaxValue

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindInput = useMemo(() => dynamic<TextFieldProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindInput)), [path])
  const FindButton = useMemo(() => dynamic<FindButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindButton)), [path])

  const handleLongIntervalSearchOnKeyUp = () => {
    clearTimeout(longIntervalSearchTimeout)

    const longIntervalTimeout = setTimeout(() => {
      handleLongIntervalSearch()
    }, 2000)

    setLongIntervalSearchTimeout(longIntervalTimeout)
  }

  const handleLongIntervalSearch = (e?: KeyboardEvent<HTMLDivElement>) => {
    if (e !== undefined && e.type === "keydown" && e.key !== "Enter") return

    let url = filters?.targetUrl?.replace('(min)', hasMinValue ? minValue.toString() : '')
    url = url?.replace('(max)', hasMaxValue ? maxValue.toString() : '')

    router.push(hasOneValue ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl as string, undefined, { scroll: false })
  }

  const handleChangeMinVal = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\s/g, '')
    value = value.replace(',', '.')

    setMinValue(parseFloat(value))
  }

  const handleChangeMaxVal = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\s/g, '')
    value = value.replace(',', '.')
    const maxValue = !Number.isNaN(parseFloat(value)) ? parseFloat(value) : undefined

    setMaxValue(maxValue)
  }

  useEffect(() => {
    setMinValue(filters?.intervalSelectedMin)
    setMaxValue(filters?.intervalSelectedMax)
  }, [filters?.intervalSelectedMin, filters?.intervalSelectedMax])
  
  return (
    <>
      <Stack
        display={"flex"}
        flexDirection={"row"}
        justifyContent={isMobile ? 'center' : undefined}
        m={isMobile ? 2 : undefined}
      >
        <Stack mr={1}>
          <NumericFormat
            customInput={FindInput}
            placeholder="-tól"
            value={minValue ?? ""}
            onChange={handleChangeMinVal}
            onKeyDown={handleLongIntervalSearch}
            onKeyUp={isMobile ? handleLongIntervalSearchOnKeyUp : undefined}
            autoComplete="off"
            thousandSeparator=" "
          />
        </Stack>
        <Stack mr={1}>
          <NumericFormat
            customInput={FindInput}
            placeholder="-ig"
            value={maxValue ?? ""}
            onChange={handleChangeMaxVal}
            onKeyDown={handleLongIntervalSearch}
            onKeyUp={isMobile ? handleLongIntervalSearchOnKeyUp : undefined}
            autoComplete="off"
            thousandSeparator=" "
            decimalSeparator=","
          />
        </Stack>
        {!isMobile ? (
          <Stack>
            <FindButton 
              bgcolor={colors.mainColor}
              bghovercolor={colors.secondaryColor}
              onClick={() => handleLongIntervalSearch()}
              variant="contained"
              inputbutton={1}
              aria-label="Keresés"
            >
              <SearchIcon fontSize="large" />
            </FindButton>
          </Stack>
        ) : null}
      </Stack>
    </>
  )
}

export default FilterLongInterval